import { FormattedMessage } from "react-intl";
import PublishedByOthersIcon from "../../../components/Common/SvgIcons/SocialIcons/PublishedByOthersIcon";
import { moderateContributions } from "./moderateContributions";

export const publishedByOthers = {
  label: <FormattedMessage id="MYCLASS_PUBLISHEDBYOTHERS" />,
  path: (tenantName) =>
    `${moderateContributions.path(tenantName)}/publishedByOthers`,
  icon: (fill) => <PublishedByOthersIcon fill={fill} />,
  searchPlaceHolder: "Search by shotclass name or date",
};
